import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';

import { LoginService } from '../../../login/login.service';
import { SwitchboardService } from '../../../switchboard/switchboard.service';
import { MediaService } from '../../../audio/media.service';
import { ServicesService } from '../../../services/services.service';

import { SwitchboardObject } from '../../../switchboard/switchboard_object';

declare var moment: any;

@Component({
    selector: 'app-portal-sips',
    templateUrl: './portal-sips.component.html',
    styleUrls: ['./portal-sips.component.css']
})
export class PortalSipsComponent implements OnInit, OnDestroy {

    @Input() account_id;

    hasAvailableServices = false;

    sips: SwitchboardObject[];
    switchboard_objects: SwitchboardObject[];
    current_number: SwitchboardObject;
    media: any[];

    services = {};

    busyLightsInterval;
    busyLights;

    isTrial = true;
    isVV = false;

    constructor(
        private authService: LoginService,
        private switchboardService: SwitchboardService,
        private mediaService: MediaService,
        private serviceService: ServicesService,
    ) { }

    ngOnInit() {
        this.authService.getCurrentAccount()
        .subscribe(account => {
            this.account_id = account.id;
            if (account.active_state == 1) {
                this.isTrial = true;
            }
            else {
                this.isTrial = false;
            }
            this.loadSips();
            this.loadSwitchboardObjects();
            this.loadMedia();
            this.busyLightsInterval = setInterval(() => this.loadBusyLights(), 30 * 1000);
        });
        this.authService.getCurrentApp()
        .subscribe(app => {
            if (app.short_name == 'vv') {
                this.isVV = true;
            }
        })
    }

    ngOnDestroy() {
        clearInterval(this.busyLightsInterval);
    }

    loadSips() {
        this.switchboardService.readSipsOnAccount(this.account_id)
            .subscribe(sips => this.sips = sips);
    }

    loadSwitchboardObjects() {
        const object_type = 'Sip';
        this.switchboardService.getSwitchboardObjectsForAccount(this.account_id)
        .subscribe(objects => {
            this.switchboard_objects = objects;
            const used_services = objects
                .filter(object => object.object_type === object_type)
                .map(object => object.service_instance_id);
            this.serviceService.getServicesForAccount(this.account_id, object_type)
            .subscribe(services => {
                const free_services = services.filter(service => !used_services.includes(service.id));
                const hasFreeServices = free_services.length > 0;
                this.hasAvailableServices ||= hasFreeServices;
                for (let service of services) {
                    this.services[service.id] = service;
                }
            });
        });

        this.serviceService.getAvailableServices(this.account_id, object_type)
            .subscribe(services => this.hasAvailableServices ||= services.length > 0);

        this.loadBusyLights();
    }

    loadBusyLights() {
        this.switchboardService.getSwitchboardBlfs(this.account_id)
            .subscribe(blfs => this.busyLights = blfs);
    }

    loadMedia() {
        this.mediaService.getSwitchboardMedia(this.account_id)
            .subscribe(media => this.media = media);
    }

    getSwitchboardObject(uuid) {
        if (this.switchboard_objects) {
            for (let object of this.switchboard_objects) {
                if (object.uuid === uuid) {
                    return object;
                }
            }
        }
        return null;
    }

}
